import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';
interface IClearModal extends IModalChildProps {
    isSaved: boolean;
}
const ClearModal = ({ onAccept, onClose, isSaved }: IClearModal) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({ id: 'Close' })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    {isSaved ? (
                        <h4 className="modal-title">
                            <FormattedMessage
                                id="Are_you_sure_you_want_clear_all_saved_cart"
                                defaultMessage={
                                    'Are you sure you want to clear all saved carts? This will clear all items in your saved carts'
                                }
                            />
                        </h4>
                    ) : (
                        <h4 className="modal-title">
                            <FormattedMessage id="Are_you_sure_you_want_clear_al" />
                        </h4>
                    )}
                </div>
                <div className="modal-footer">
                    {isSaved ? (
                        <button className="btn btn-info" onClick={onAccept}>
                            <FormattedMessage
                                id="Clear_All_Saved_Cart"
                                defaultMessage={'Clear All Saved Cart'}
                            />
                        </button>
                    ) : (
                        <button className="btn btn-info" onClick={onAccept}>
                            <FormattedMessage id="Clear_All_Cart" />
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Cancel" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default ClearModal;
